import React from 'react';
import { PageRestricted } from 'pages/errors/page-restricted';
import { RiskProfile } from 'pages/risk/shared';
import { UserAccess } from 'components/user-access';

export function RiskOrganisationProfile(props) {

    return (
        <UserAccess perform={["Risk:View"]}
            yes={() => (
                <RiskProfile 
                    title="Organisation Risk"
                    riskEntityType="Organisation"
                    riskEntityController="Organisation"
                    profileResponseMapper={() => {return []}}
                    breadcrumbs={props.breadcrumbs}
                />
            )}
            no={() => (
                <PageRestricted />
            )}
        />

    );
}